'use client'
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';
import { toast } from 'react-toastify';
import { getCookie, login } from '@/utils/apiService';

const LoginPage = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const router = useRouter();

    useEffect(() => {
        const cookie = getCookie("phone_number");
        if (cookie){
            window.location.href = '/profile'
        }
      }, []);
    

    const handleLogin = async () => {
        if (!phoneNumber || !password) {
            setError('Бүх талбарыг бөглөнө үү.');
            return;
        }
        try {
            await login(phoneNumber, password);
            toast.success('Амжилттай нэвтэрлээ');
            router.push('/profile');
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response?.status === 400 || error.response?.status === 401) {
                    toast.error('Нэвтрэх боломжгүй байна. Та утасны дугаар болон нууц үгээ шалгана уу.');
                    setPassword('');
                } else {
                    toast.error('Системд холбогдоход алдаа гарлаа. Та дараа дахин оролдоно уу.');
                }
            } else {
                toast.error('Системд холбогдоход алдаа гарлаа. Та дараа дахин оролдоно уу.');
            }
        }
    };

    const handleKeyDown = (e: { key: string }) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <div className='h-screen w-screen bg-white md:bg-purple-50 dark:md:bg-dark-800 dark:bg-dark-600'>
            <div className="flex flex-col justify-center items-center h-screen">
                <div className='p-14'>
                    <Link href="/">
                        <div>
                            <Image
                                src="/logo-black-vector.svg"
                                alt="Logo Light Mode"
                                className="dark:hidden"
                                width={260}
                                height={30}
                                priority
                            />
                            <Image
                                src="/logo-white-vector.svg"
                                alt="Logo Dark Mode"
                                className="hidden dark:block"
                                width={260}
                                height={60}
                                priority
                            />
                        </div>
                    </Link>
                </div>

                <div className="w-full max-w-md p-8 bg-white dark:bg-dark-600 md:shadow-md md:rounded-xl space-y-5">
                    <h1 className="text-2xl font-bold mb-4 text-center">Тавтай морил!</h1>
                    {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
                    <input
                        type="text"
                        placeholder="Утасны дугаар"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="w-full p-4 border border-gray-300 rounded-lg mb-4 text-dark-700"
                    />
                    <input
                        type="password"
                        placeholder="Нууц үг"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={handleKeyDown}
                        className="w-full p-4 border border-gray-300 rounded-lg mb-4  text-dark-700"
                    />
                    <button
                        onClick={handleLogin}
                        className="  w-full font-bold p-4 text-md bg-purple-500 text-white rounded-lg hover:bg-purple-600"
                    >
                        Нэвтрэх
                    </button>

                    <div className='mt-8 pt-5 border-t-2 border-gray-200 text-center text-sm'>
                        <div>
                            <span className='text-center font-semibold text-gray-600 dark:text-white'>Нууц үгээ мартсан?</span>
                            <Link href="/recover">
                                <span className='ms-2 font-semibold text-center underline hover:cursor-pointer'>Сэргээх</span>
                            </Link>
                        </div>
                        <div className='mt-2'>
                            <span className='text-center font-semibold text-gray-600 dark:text-white'>Шинээр орж байгаа?</span>
                            <Link href="/register">
                                <span className='ms-2 font-semibold text-center underline hover:cursor-pointer'>Бүртгүүлэх</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;